<template>
    <el-dialog :title="title1" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" fullscreen>
        <div class="carBox">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>时间段：</label>
                        <el-time-picker is-range v-model="dateRange" value-format="HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围"
                            @change="dateRangeSet">
                        </el-time-picker>
                    </div>
                    <el-button type="primary" plain @click.native="filerData">筛选</el-button>
                    <el-button type="primary"  @click="exportData">导出</el-button>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" v-loading="loading" border stripe height="700">
                        <el-table-column prop="time" label="时间" width="80">
                            <template slot-scope="scope">
                                <span>{{ formatDate(scope.row.time, "HH:mm:ss") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="head_code" label="报文头"></el-table-column>
                        <el-table-column prop="function_code" label="编码"></el-table-column>
                        <el-table-column label="通道1" align="center">
                            <el-table-column prop="volumeIn1" label="进浆流量"></el-table-column>
                            <el-table-column prop="volumeLeak1" label="返浆流量"></el-table-column>
                            <el-table-column prop="pressure1" label="压力"></el-table-column>
                            <el-table-column prop="density1" label="密度"></el-table-column>
                            <el-table-column prop="volumeInException1" label="进浆异常"></el-table-column>
                            <el-table-column prop="volumeLeakException1" label="返浆异常"></el-table-column>
                            <el-table-column prop="pressureException1" label="压力异常"></el-table-column>
                            <el-table-column prop="densityException1" label="密度异常"></el-table-column>
                        </el-table-column>
                        <el-table-column label="通道2" align="center">
                            <el-table-column prop="volumeIn2" label="进浆流量"></el-table-column>
                            <el-table-column prop="volumeLeak2" label="返浆流量"></el-table-column>
                            <el-table-column prop="pressure2" label="压力"></el-table-column>
                            <el-table-column prop="density2" label="密度"></el-table-column>
                            <el-table-column prop="volumeInException2" label="进浆异常"></el-table-column>
                            <el-table-column prop="volumeLeakException2" label="返浆异常"></el-table-column>
                            <el-table-column prop="pressureException2" label="压力异常"></el-table-column>
                            <el-table-column prop="densityException2" label="密度异常"></el-table-column>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes,prev, pager, next, jumper" :current-page="current" :page-size="pagesize" :page-sizes="[50, 100, 200]" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil";
import { filterFileData, exportFileData } from "@/api/messagelog";

export default {
    name: "roleList",
    mixins: [listutil],
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        folder: {
            type: String,
            default() {
                return '';
            }
        },
        fileName: {
            type: String,
            default() {
                return '';
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if(newv){
                this.title1 = this.title+'【 '+this.folder+' 】'+'【 '+this.fileName.replace('.txt', '')+' 】'
                this.tableData = []
            }
        },
    },
    data() {
        return {
            m_name: '筛选文件数据',
            menu_id: 1921,
            list_url: "/api/admin/messagelog/filterFileData",
            search_Obj: {
                f_user_id: '',
            },
            del_Obj:{
                url:'/api/admin/messagelog/delabc',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            title1: '',
            showflag: false,
            pagesize: 100,
            allData: [],
            dateRange: [new Date(2016, 9, 10, 0, 0), new Date(2016, 9, 10, 23, 0)],
            start_time: '00:00:00',
            end_time: '05:00:00',
        };
    },
    mounted() {},
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.start_time = val[0]
                this.end_time = val[1]
            }else{
                this.start_time = ''
                this.end_time = ''
            }
            
        },
        filerData(){
            this.loading = true
            filterFileData(this.folder, this.fileName, this.start_time, this.end_time).then(res=>{
                this.loading = false
                if(res.code == 1){
                    this.allData = res.data
                    this.total = res.data.length
                    this.updateData()
                }else{
                    this.tableData = []
                    this.$msg(res.msg)
                }
            })
        },
        pageChange(page) {
            this.current = page
            this.updateData()
        },
        handleSizeChange(val){
            this.pagesize = val
            this.current = 1
            this.updateData()
        },
        updateData(){
            const startIndex = (this.current - 1) * this.pagesize;
            const endIndex = startIndex + this.pagesize;
            this.tableData = this.allData.slice(startIndex, endIndex);
        },
        exportData(){
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            exportFileData(this.folder, this.fileName, this.start_time, this.end_time).then(res=>{
                loading.close()
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>